'use strict';

/* globals app, moment, TMPlus */

(function () {
	const ROOM_TYPES = {
		1: 'Unknown',
		2: 'Lobby',
		3: 'Conference(2-way)',
		9: 'Conference',
	};
	const view = {};

	function serialize(room, { isTopicOwner }) {
		const {
			sessionOptions,
			members,
			domain,
		} = room;

		if (!(sessionOptions && members)) { return null; }

		const links = [];
		members.forEach(({ identityKey, token }, i) => {
			if (!(identityKey && token)) { return; }
			const isHostLink = i === 0;
			if (isHostLink && !isTopicOwner) { return; }
			const name = identityKey.replace(isHostLink ? 'consultant_' : 'student_', '');
			links.push({
				name,
				isHost: isHostLink,
				link: `${domain}/v2/render?token=${token}`,
				playbackLink: `${domain}/v2/render/playback?mode=playback&token=${token}`,
			});
		});

		return {
			startTime: new Date(sessionOptions.startTime).toLocaleString(),
			duration: moment.duration(sessionOptions.duration).humanize(),
			roomType: ROOM_TYPES[sessionOptions.roomType],
			links,
		};
	}

	view.load = (room) => {
		console.log({ room });
		require(['components'], (components) => {
			const posts = components.get('post');

			if (!posts.length) { return; }

			const post = posts.eq(0);
			if (parseInt(post.data('pid'), 10) !== parseInt(room.pid, 10)) { return; }

			const content = post.find('[component="post/content"]');
			const postUid = post.data('uid');
			const isTopicOwner = postUid === app.user.uid; // TODO: Get Uid from "app" is not safe, which can be modified by user
			const tempateData = serialize(room, { isTopicOwner });
			if (!tempateData) { return null; }
			console.log({ posts, content, tempateData });

			app.parseAndTranslate('tmplus/sessionRoom', tempateData, (container) => {
				console.log({ container });
				content.append(container);
			});
		});
	};

	TMPlus.view = view;
}());
